export default {
  tianDiTu: 'http://t4.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=b782df90edef3e604fa19092c5b5e199',
  owsUrl: '/geoserver/GXS/ows',
  wmsUrl: '/geoserver/GXS/wms',
  code: 'code',
  region1: {
    layer: 'GXS:451000_xzqh',
    extent: [13539263.123999998, 4991687.817500003, 14617853.254999999, 5828412.055700002],
    code: '市代码',
    name: '市'
  },

  region2: {
    layer: 'GXS:451022_xzqh',
    extent: [13540851.235100001, 4992626.1603000015, 14617343.4273, 5829148.4252],
    code: 'PAC',
    name: 'NAME'
  },
  region3: {
    layer: 'GXS:45_xian_xzqh',
    extent: [13539263.123999998, 4991687.817500003, 14617853.254999999, 5828412.055700002],
    code: 'code',
    name: 'name'
  },
  tiandong: {
    layer: 'GXS:xzqh_451022',
    extent: [13539263.123999998, 4991687.817500003, 14617853.254999999, 5828412.055700002],
    code: 'XZQDM',
    name: 'XZQMC'
  }
};
